import { render, staticRenderFns } from "./SrFieldRepForm.vue?vue&type=template&id=45634be7&"
import script from "./SrFieldRepForm.vue?vue&type=script&lang=js&"
export * from "./SrFieldRepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports